import { render, staticRenderFns } from "./BomManager.vue?vue&type=template&id=74c47440"
import script from "./BomManager.vue?vue&type=script&lang=js"
export * from "./BomManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports